"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineModule = void 0;
var engine_producer_1 = require("@verified/c11-engine.producer");
var engine_types_1 = require("@verified/c11-engine.types");
var engine_utils_1 = require("@verified/c11-engine.utils");
var EngineModule = /** @class */ (function () {
    function EngineModule(db, module) {
        this.state = engine_types_1.EngineModuleState.NOT_BOOTSTRAPPED;
        this.producers = [];
        this.sourceUpdateListeners = {};
        this.source = module;
        this.db = db;
        this.context = {
            onSourceUpdate: this.addSourceUpdateListener.bind(this),
            addProducer: this.addProducer.bind(this),
        };
    }
    EngineModule.prototype.addSourceUpdateListener = function (sourceId, cb) {
        var _this = this;
        var id = (0, engine_utils_1.randomId)();
        if (!this.sourceUpdateListeners[sourceId]) {
            this.sourceUpdateListeners[sourceId] = {};
        }
        this.sourceUpdateListeners[sourceId][id] = cb;
        return function () {
            delete _this.sourceUpdateListeners[sourceId][id];
        };
    };
    EngineModule.prototype.addProducer = function (config, extendedContext) {
        if (extendedContext === void 0) { extendedContext = {}; }
        var context = __assign({ db: this.db }, extendedContext);
        // @ts-ignore
        var producer = new engine_producer_1.Producer(config, context);
        this.producers.push(producer);
        return producer;
    };
    EngineModule.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state === engine_types_1.EngineModuleState.MOUNTED ||
                            this.state === engine_types_1.EngineModuleState.BOOTSTRAPING) {
                            return [2 /*return*/];
                        }
                        if (!(this.source.bootstrap &&
                            this.state === engine_types_1.EngineModuleState.NOT_BOOTSTRAPPED)) return [3 /*break*/, 2];
                        this.state = engine_types_1.EngineModuleState.BOOTSTRAPING;
                        return [4 /*yield*/, this.source.bootstrap()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.state = engine_types_1.EngineModuleState.NOT_MOUNTED;
                        return [4 /*yield*/, this.source.mount(this.context)];
                    case 3:
                        _a.sent();
                        this.state = engine_types_1.EngineModuleState.MOUNTED;
                        return [2 /*return*/];
                }
            });
        });
    };
    EngineModule.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state = engine_types_1.EngineModuleState.UNMOUNTING;
                        return [4 /*yield*/, this.source.unmount(this.context)];
                    case 1:
                        _a.sent();
                        this.state = engine_types_1.EngineModuleState.NOT_MOUNTED;
                        return [2 /*return*/];
                }
            });
        });
    };
    EngineModule.prototype.update = function (sourceId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.sourceUpdateListeners[sourceId]) {
                    Object.values(this.sourceUpdateListeners[sourceId]).forEach(function (x) {
                        return x(config);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return EngineModule;
}());
exports.EngineModule = EngineModule;
//# sourceMappingURL=data:application/json;base64,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